export default {"src":"/_next/static/media/insurance.df5ba044.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};